import styled from 'styled-components';
import variables from '../style/variables';

const {
    spd_blue,
    screen_sm
} = variables;

export const HeaderEL = styled.header`
    width           : 100%;
    height          : 51px;
    position        : relative;
    background-color: #545a62;
    overflow        : hidden;

    @media(max-width: ${screen_sm}){
        background-color: #ffffff;
        box-shadow: rgba(54, 69, 73, 0.14) 0px 1px 5px 0px;
        position: fixed;
        top:0;
        z-index: 9;
    }
`;

export const AbtnHeader = styled.a`
    border-radius: 20px;
    height: 35px; 
    padding: 4px 12px;
    border-style: solid;
    border-width: 2px;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    &:hover {
        color: ${spd_blue};
        text-decoration: none;
    }
`;

export const NavbarTopLeft = styled.div`
    height: 51px;
    ul {
        top: 50%;
        position: absolute;
        padding: 0;
        margin: 0;
        list-style: none;
    
        li {
            float: left;
            margin-right: 20px;
            i {
                color: #ffffff;
                width: 100%;
                position: relative;
                top: 50%;
                -moz-transform: translateY(-50%);
                -o-transform: translateY(-50%);
                -ms-transform: translateY(-50%);
                -webkit-transform: translateY(-50%);
                transform: translateY(-50%);
            }
        }
    }
`;

export const NavbarTopRight = styled.div`
    right: 15px;
    position: absolute;
    top: 50%;
    -moz-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);

    ul {
        padding: 0;
        margin: 0;
        list-style: none;

        li {
            display: inline-block;
            vertical-align: middle;
            margin-left: 18px;
        }

        .flag.active img {
            opacity: 1;
        }
        .flag img {
            opacity: 0.3;
            width: 25px;
        }

    }
`;

export const NavMobile = styled.div`
    display: none;

    .toggle_menu {
        left: 15px;
        position: absolute;
        top: 50%;
        -moz-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        cursor: pointer;
        height: 21px;
        display: block;
        z-index: 9;
    }

    .logo_mobile {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        -moz-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        
        img {
            height: 25px;
            vertical-align: middle;
        }
    }

    .menu_left {
        width: 280px;
        height: 100%;
        background-color: #ffffff;
        position: fixed;
        z-index: 999;
        transform: translateX(-100%);
        -moz-transition: all 0.25s ease-in-out;
        -o-transition: all 0.25s ease-in-out;
        -webkit-transition: all 0.25s ease-in-out;
        transition: all 0.25s ease-in-out;
        
        &.active {
            transform: translateX(0);
            box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px 2px;
        }

        .close {
            height: 30px;
            width: 30px;
            position: absolute;
            right: 0;
            top: 0;
            text-align: center;
            padding-top: 2px;
            cursor: pointer;
            
            i {
                font-size: 18px;
            }
        }

        ul {
            list-style: none;
            padding: 12px 0;

            li {
                padding: 10px 20px;
                border-bottom: 1px solid #f2f2f2f2;

                a {
                    font-size: 14px;
                    letter-spacing: 0.2px;
                    color: #2f3843;
                    display: inline-block;
                    text-decoration: none;
                    
                    &:hover {
                        text-decoration: underline;
                    }
                    &.active {
                        font-weight: bold;
                        color: #2267a1;
                        pointer-events: none;
                    }
                }

                .flag.active img {
                    opacity: 1;
                }
                .flag img {
                    opacity: 0.3;
                    width: 25px;
                }
            }

 
        }
    }
    
    @media(max-width: ${screen_sm}) {
        display: block;
    }
`;


// WEBPACK FOOTER //
// ./src/components/style/header.jsx